import { createIcon } from '../icon'
import TracksuitIcon from '../svg/TracksuitIcon'

export const TracksuitIconDefault = createIcon(TracksuitIcon)
